import { useEffect } from 'react';
import { Control, FieldValues, useFormState, useWatch } from 'react-hook-form';
import { useReactFlowStore } from 'assets/js/pages/engage/workflows/utils/store';
import { NodeWithData } from 'assets/js/pages/engage/workflows/utils/types';

interface UseSyncFormToNode<T extends FieldValues> {
    nodeId: string;
    control: Control<T>;
}

const useSyncFormToNode = <T extends FieldValues>({ control, nodeId }: UseSyncFormToNode<T>) => {
    const { getNode, updateNode } = useReactFlowStore(({ getNode, updateNode }) => ({
        getNode,
        updateNode,
    }));
    const values = useWatch({ control });
    const { isValid, isDirty, errors } = useFormState({ control });

    useEffect(() => {
        const node = getNode(nodeId);

        if (node) {
            const newNode = {
                ...node,
                data: {
                    ...node.data,
                    formData: {
                        values,
                        isDirty,
                        isValid,
                        errors,
                    },
                },
            } as NodeWithData;
            updateNode(nodeId, newNode);
        }
    }, [values, getNode, updateNode, nodeId, isValid, isDirty, errors]);
};

export { useSyncFormToNode };
